import React from "react";
import { useScrollShadow } from "../../hooks/useScrollShadow";
import styles from "./ScrollShadow.module.css";

export default function ScrollShadowBox({ children, className = "" }) {
  const { ref, hasTopShadow, hasBottomShadow } = useScrollShadow();

  return (
    <div className={`${styles.container} ${className}`}>
      {hasTopShadow && (
        <div className={`${styles.topShadow} ${styles.visible}`} />
      )}
      {hasBottomShadow && (
        <div className={`${styles.bottomShadow} ${styles.visible}`} />
      )}

      <div ref={ref} className={styles.scrollArea}>
        {children}
      </div>
    </div>
  );
}
